import { render, staticRenderFns } from "./MeetingPurposeList.vue?vue&type=template&id=4a45131e&"
import script from "./MeetingPurposeList.vue?vue&type=script&lang=js&"
export * from "./MeetingPurposeList.vue?vue&type=script&lang=js&"
import style0 from "./MeetingPurposeList.vue?vue&type=style&index=0&id=4a45131e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports